<template>
  <div class="device-static-page">
    <management-table
      title="设备报表"
      eyebrow="Device Report"
      :data="safeTableData"
      :loading="tableLoading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="totalV1"
      empty-text="暂无数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item search-item-sm">
          <label class="search-label">DTU编号:</label>
          <el-input v-model="query.serNo" placeholder="请输入DTU编号" clearable class="search-input" @clear="handleClear" />
        </div>

        <div class="search-item search-item-device">
          <label class="search-label">控制器选择:</label>
          <el-select
            v-model="query.deviceName"
            clearable
            placeholder="请选择控制器"
            class="search-select"
            popper-class="device-static-popper"
            filterable
            :filter-method="deviceFilterMethod"
            @focus="handleDeviceFocus"
            @clear="handleClear"
          >
            <el-option
              v-for="item in filteredDeviceList"
              :key="item.imei"
              :label="item.stationName"
              :value="item.imei"
            />
          </el-select>
        </div>

        <div class="search-item search-item-date">
          <label class="search-label">查询区间:</label>
          <el-date-picker
            v-model="value1"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="search-date"
            popper-class="device-static-popper"
            @change="wsss"
          />
        </div>

        <div class="search-item search-item-export">
          <label class="search-label">导出类型:</label>
          <el-select v-model="query.exportType" placeholder="选择模式" class="search-select" popper-class="device-static-popper">
            <el-option value="1" key="1" label="按月" />
            <el-option value="2" key="2" label="按年" />
            <el-option value="4" key="4" label="累计" />
          </el-select>
        </div>

        <div v-if="query.exportType == 1" class="search-item search-item-time">
          <el-date-picker
            v-model="value2"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM"
            placeholder="选择月份"
            class="search-date"
            popper-class="device-static-popper"
          />
        </div>

        <div v-if="query.exportType == 2" class="search-item search-item-time">
          <el-date-picker
            v-model="value3"
            type="year"
            format="yyyy"
            value-format="yyyy"
            placeholder="选择年份"
            class="search-date"
            popper-class="device-static-popper"
          />
        </div>
      </template>

      <template slot="actions">
        <el-button
          type="primary"
          icon="el-icon-download"
          class="export-btn"
          :disabled="!query.exportType"
          @click="exportData"
        >
          导出
        </el-button>
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="serch">搜索</el-button>
      </template>

      <template slot="columns">
        <el-table-column label="电站名称" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.stationName }}</template>
        </el-table-column>
        <el-table-column label="DTU编号" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.imei }}</template>
        </el-table-column>
        <el-table-column label="设备名称" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.deviceName }}</template>
        </el-table-column>
        <el-table-column label="设备类型" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.deviceType }}</template>
        </el-table-column>
        <el-table-column label="日期" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.kpiDay }}</template>
        </el-table-column>
        <el-table-column label="日发电量" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.todayFaDianLiang }}kwh</template>
        </el-table-column>
        <el-table-column label="当前值" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.currentValue }}</template>
        </el-table-column>
        <el-table-column label="月份" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.kpiMonth }}</template>
        </el-table-column>
        <el-table-column label="月发电量" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.monthFaDianLiang }}kwh</template>
        </el-table-column>
        <el-table-column label="总发电量" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.totalFaDianLiang }}kwh</template>
        </el-table-column>
      </template>
    </management-table>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue';

export default {
  components: {
    ManagementTable
  },
  data() {
    return {
      value1: [],
      deviceList: [],
      filteredDeviceList: [],
      value3: '',
      value2: '',
      tableDataV1: [],
      tableLoading: false,
      totalV1: 0,
      hasSearched: false,
      query: {
        stationName: '',
        deviceName: '',
        exportType: '',
        pageNum: 1,
        pageSize: 10,
        serNo: '',
        startTime: '',
        endTime: '',
        kpiTime: ''
      }
    }
  },
  computed: {
    safeTableData() {
      return Array.isArray(this.tableDataV1) ? this.tableDataV1 : [];
    }
  },
  created() {
    this.loadPage();
    this.loadAllList();
  },
  methods: {
    wsss(e) {
      this.value1 = e;
      this.loadPage();
    },
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000, deviceType: 1 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        const resData = response && response.data ? response.data : {};
        if (resData.result) {
          const data = resData.data || {};
          this.deviceList = Array.isArray(data.list) ? data.list : [];
          this.filteredDeviceList = this.deviceList;
        } else {
          this.deviceList = [];
          this.filteredDeviceList = [];
          this.$Message.error('获取控制器列表失败，请联系管理员!');
        }
      }).catch(() => {
        this.deviceList = [];
        this.filteredDeviceList = [];
        this.$Message.error('网络异常，获取控制器列表失败!');
      })
    },
    deviceFilterMethod(val) {
      if (!val) {
        this.filteredDeviceList = this.deviceList;
        return;
      }
      const keyword = val.toLowerCase();
      this.filteredDeviceList = this.deviceList.filter(item =>
        item.stationName && item.stationName.toLowerCase().startsWith(keyword)
      );
    },
    handleDeviceFocus() {
      this.filteredDeviceList = this.deviceList;
    },
    exportData() {
      if ((this.query.exportType == 1 && this.value2 == '') || (this.query.exportType == 2 && this.value3 == '')) {
        this.$Message.warning('请选择导出的月份或年份!');
        return;
      }
      if (this.query.exportType == 1) {
        this.query.kpiTime = this.value2;
      }
      if (this.query.exportType == 2) {
        this.query.kpiTime = this.value3;
      }
      if (this.query.exportType == 4) {
        this.query.kpiTime = '';
      }
      if (this.value1 && this.value1.length > 0) {
        this.query.startTime = this.value1[0];
        this.query.endTime = this.value1[1];
      }
      this.$request({
        timeout: 300000,
        url: '/api/device/export/fadian',
        method: 'POST',
        responseType: 'blob',
        data: this.query
      }).then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.query.kpiTime}设备报表数据导出.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.$Message.success('报表导出成功!');
      }).catch(() => {
        this.$Message.error('报表导出失败，请联系管理员!');
      })
    },
    loadPage() {
      if (this.value1 && this.value1.length > 0) {
        this.query.startTime = this.value1[0];
        this.query.endTime = this.value1[1];
      }
      this.tableLoading = true;
      this.$request.post('/api/device/static/page', this.query).then(response => {
        const resData = response && response.data ? response.data : {};
        if (resData.result) {
          const data = resData.data || {};
          this.tableDataV1 = Array.isArray(data.list) ? data.list : [];
          this.totalV1 = Number(data.totalCount) || 0;
        } else {
          this.tableDataV1 = [];
          this.totalV1 = 0;
          this.$Message.error('获取发电量数据失败，请联系管理员!');
        }
      }).catch(() => {
        this.tableDataV1 = [];
        this.totalV1 = 0;
        this.$Message.error('网络异常，获取发电量数据失败!');
      }).finally(() => {
        this.tableLoading = false;
      })
    },
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    serch() {
      this.hasSearched = true;
      this.query.pageNum = 1;
      this.loadPage();
    },
    handleClear() {
      if (this.hasSearched) {
        this.serch();
      }
    }
  }
}
</script>

<style>
.device-static-popper {
  background-color: var(--solar-surface, #002b4d) !important;
  border: 1px solid var(--solar-border-strong, #0099ff) !important;
}

.device-static-popper .el-select-dropdown__item {
  color: var(--solar-text, #87cefa) !important;
}

.device-static-popper .el-select-dropdown__item.hover,
.device-static-popper .el-select-dropdown__item:hover {
  background-color: var(--solar-raised, #003c66) !important;
  color: var(--solar-primary, #00ccff) !important;
}

.device-static-popper .el-date-picker,
.device-static-popper .el-picker-panel,
.device-static-popper .el-date-range-picker {
  background-color: var(--solar-surface, #002b4d) !important;
  color: var(--solar-text, #87cefa) !important;
}

.device-static-popper .el-date-table th,
.device-static-popper .el-picker-panel__icon-btn,
.device-static-popper .el-date-range-picker__header,
.device-static-popper .el-date-range-picker__content .el-date-range-picker__header div {
  color: var(--solar-text-strong, #b0e2ff) !important;
}

.device-static-popper .el-date-table td.available:hover {
  color: var(--solar-primary, #00ccff) !important;
}
</style>

<style scoped>
.device-static-page {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.device-static-page .search-item {
  min-width: 0;
}

.device-static-page .search-item-sm {
  flex: 0 1 230px;
}

.device-static-page .search-item-device {
  flex: 0 1 250px;
}

.device-static-page .search-item-date {
  flex: 0 1 390px;
  min-width: 340px;
}

.device-static-page .search-item-export,
.device-static-page .search-item-time {
  flex: 0 1 210px;
  min-width: 180px;
}

.search-date {
  flex: 1 1 auto;
  width: auto !important;
  min-width: 0;
}

/deep/ .search-date.el-date-editor.el-input {
  height: 36px !important;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.58) !important;
  border-radius: 4px !important;
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.72) !important;
  box-shadow: none !important;
  box-sizing: border-box;
  overflow: hidden;
}

/deep/ .search-date.el-date-editor.el-input .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--solar-text-strong, #dff8ff) !important;
  box-shadow: none !important;
}

/deep/ .search-date.el-date-editor--daterange {
  display: inline-flex !important;
  align-items: center !important;
  width: 100% !important;
  height: 36px !important;
  padding: 0 10px !important;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.58) !important;
  border-radius: 4px !important;
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.72) !important;
  box-shadow: none !important;
  box-sizing: border-box;
}

/deep/ .search-date.el-date-editor--daterange .el-range__icon,
/deep/ .search-date.el-date-editor--daterange .el-range-separator,
/deep/ .search-date.el-date-editor--daterange .el-range__close-icon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  float: none !important;
  height: 34px !important;
  line-height: 34px !important;
  margin: 0 !important;
  padding: 0 !important;
  color: var(--solar-text, #87cefa) !important;
}

/deep/ .search-date.el-date-editor--daterange .el-range__icon {
  flex: 0 0 20px;
}

/deep/ .search-date.el-date-editor--daterange .el-range-separator {
  flex: 0 0 28px;
  width: 28px !important;
}

/deep/ .search-date.el-date-editor--daterange .el-range-input {
  flex: 1 1 0;
  min-width: 0;
  height: 34px !important;
  line-height: 34px !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--solar-text-strong, #dff8ff) !important;
  box-shadow: none !important;
  text-align: center;
}

/deep/ .search-date.el-date-editor.el-input:hover,
/deep/ .search-date.el-date-editor.el-input:focus-within,
/deep/ .search-date.el-date-editor--daterange:hover,
/deep/ .search-date.el-date-editor--daterange.is-active {
  border-color: rgba(var(--solar-border-strong-rgb, 0, 204, 255), 0.85) !important;
}

/deep/ .search-date .el-input__inner::placeholder,
/deep/ .search-date .el-range-input::placeholder {
  color: rgba(var(--solar-text-rgb, 135, 206, 250), 0.62) !important;
}

/deep/ .export-btn.el-button {
  min-width: 96px;
  height: 36px;
  margin-left: 0 !important;
  border-color: var(--solar-border-strong, #00ccff) !important;
  border-radius: 4px;
  background: var(--solar-primary, #00ccff) !important;
  color: var(--solar-on-primary, #002b4d) !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

/deep/ .export-btn.el-button:hover,
/deep/ .export-btn.el-button:focus {
  border-color: var(--solar-border-strong, #0099ff) !important;
  background: var(--solar-primary, #0099ff) !important;
}

/deep/ .export-btn.el-button.is-disabled,
/deep/ .export-btn.el-button.is-disabled:hover,
/deep/ .export-btn.el-button.is-disabled:focus {
  opacity: 0.55;
}

@media (max-width: 1200px) {
  .device-static-page /deep/ .management-table-search-actions {
    flex: 1 0 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
}

@media (max-width: 760px) {
  .device-static-page .search-item,
  .device-static-page .search-item-sm,
  .device-static-page .search-item-device,
  .device-static-page .search-item-date,
  .device-static-page .search-item-export,
  .device-static-page .search-item-time {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
  }

  .device-static-page /deep/ .management-table-search-actions {
    flex: none;
  }

  .device-static-page /deep/ .export-btn.el-button,
  .device-static-page /deep/ .search-btn.el-button {
    width: 100%;
    min-width: 0;
  }
}
</style>
